export default {
  id: 'pi_1Hem8AHEOCSwhqQok0qkyzOS',
  object: 'payment_intent',
  amount: 1000,
  amount_capturable: 0,
  amount_received: 1000,
  application: null,
  application_fee_amount: null,
  canceled_at: null,
  cancellation_reason: null,
  capture_method: 'manual',
  charges: {
    object: 'list',
    data: [
      {
        id: 'ch_1Hem8DHEOCSwhqQooRQvjBAa',
        object: 'charge',
        amount: 1000,
        amount_captured: 1000,
        amount_refunded: 0,
        application: null,
        application_fee: null,
        application_fee_amount: null,
        authorization_code: '123456',
        balance_transaction: 'txn_1Hem8FHEOCSwhqQouTR0w2rX',
        billing_details: {
          address: {
            city: null,
            country: null,
            line1: null,
            line2: null,
            postal_code: null,
            state: null,
          },
          email: null,
          name: null,
          phone: null,
        },
        calculated_statement_descriptor: 'Stripe',
        captured: true,
        created: 1603305233,
        currency: 'usd',
        customer: null,
        description: null,
        destination: null,
        dispute: null,
        disputed: false,
        failure_code: null,
        failure_message: null,
        fraud_details: {},
        invoice: null,
        livemode: false,
        metadata: {},
        on_behalf_of: null,
        order: null,
        outcome: {
          network_status: 'approved_by_network',
          reason: null,
          risk_level: 'not_assessed',
          seller_message: 'Payment complete.',
          type: 'authorized',
        },
        paid: true,
        payment_intent: 'pi_1Hem8AHEOCSwhqQok0qkyzOS',
        payment_method: 'pm_1Hem8DHEOCSwhqQogaQ0gPKE',
        payment_method_details: {
          card_present: {
            brand: 'visa',
            cardholder_name: null,
            country: 'US',
            emv_auth_data: '8A023030',
            exp_month: 12,
            exp_year: 2028,
            fingerprint: 'i4JwKTn1jKYbiifl',
            funding: 'credit',
            generated_card: 'pm_1Hem8DHEOCSwhqQogOoOrBxX',
            last4: '4242',
            network: 'visa',
            read_method: 'contact_emv',
            receipt: {
              account_type: 'credit',
              application_cryptogram: null,
              application_preferred_name: null,
              authorization_code: null,
              authorization_response_code: '3030',
              cardholder_verification_method: null,
              dedicated_file_name: null,
              terminal_verification_results: null,
              transaction_status_information: null,
            },
          },
          type: 'card_present',
        },
        receipt_email: null,
        receipt_number: null,
        receipt_url:
          'https://pay.stripe.com/receipts/acct_1HKoyWHEOCSwhqQo/ch_1Hem8DHEOCSwhqQooRQvjBAa/rcpt_IFGf3ubFlJFwV2bFUZeIgwXa6uFKZW3',
        refunded: false,
        refunds: {
          object: 'list',
          data: [],
          has_more: false,
          total_count: 0,
          url: '/v1/charges/ch_1Hem8DHEOCSwhqQooRQvjBAa/refunds',
        },
        review: null,
        shipping: null,
        source: null,
        source_transfer: null,
        statement_descriptor: null,
        statement_descriptor_suffix: null,
        status: 'succeeded',
        transfer_data: null,
        transfer_group: null,
      },
    ],
    has_more: false,
    total_count: 1,
    url: '/v1/charges?payment_intent=pi_1Hem8AHEOCSwhqQok0qkyzOS',
  },
  client_secret: 'pi_1Hem8AHEOCSwhqQok0qkyzOS_secret_WxBy0t0XsdzmIEomp4KaxbpZd',
  confirmation_method: 'automatic',
  created: 1603305230,
  currency: 'usd',
  customer: null,
  description: null,
  invoice: null,
  last_payment_error: null,
  livemode: false,
  metadata: {},
  next_action: null,
  on_behalf_of: null,
  payment_method: 'pm_1Hem8DHEOCSwhqQogaQ0gPKE',
  payment_method_options: {},
  payment_method_types: ['card_present'],
  receipt_email: null,
  review: null,
  setup_future_usage: null,
  shipping: null,
  source: null,
  statement_descriptor: null,
  statement_descriptor_suffix: null,
  status: 'succeeded',
  transfer_data: null,
  transfer_group: null,
};
